import Button from './Button'
import Group from './Group'
import Circle from './Radio'
const Radio = { Button, Group, Radio: Circle }
export { Button, Group, Circle as Radio }
export default Radio
